import { Table, Tag, Typography } from 'antd'
import { get, isEmpty } from 'lodash';
import { useCxComplaintTicket } from 'modules/CreateTicket/store';
import React, { useEffect, useMemo, useState } from 'react'
import CustomerComplaintTikcetFilter from './CustomerComplaintTikcetFilter';
import moment from 'moment';
import { subCategoryMap } from 'modules/navbar/top/helper';
import { removeSpaces } from 'modules/utilities/utility';
const { Link } = Typography;

const CustomerComplaintTickets = ({tab}) => {
  const { ticketData, ticketLoading, rowCount, fetchCxComplaintTicket} = useCxComplaintTicket();
  const[selectedStatus, setSelectedStatus] = useState();
	const [query, setQuery] = useState('');
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date().setDate(new Date().getDate() + 7));
	const [newPage, setNewPage] = useState(1);
  const [agentQuery, setAgentQuery] = useState('');
	
  useEffect(() => fetchCustomerTicket(), [startDate, endDate, tab, newPage, query]);
  
  let inputQuery;
  
  const fetchCustomerTicket = () =>{
        const sd = startDate;
        const ed = endDate;
        if(sd && ed){
          fetchCxComplaintTicket(moment(sd).toISOString(), moment(ed).toISOString(), newPage, query);
        }
  }  
    
  const dataSource = useMemo(()=>{
    if(!ticketData || isEmpty(ticketData)){
      return [];
    }
    return ticketData.map((ticket)=>({
      key: ticket._id,
      'ticket-id': ticket._id,
      'ticket-date': moment(ticket.createdAt).format('HH:MM A DD-MMM-YYYY'),
      'order-id': get(ticket,'orderId', 'N/A'),
      'cx-profile-link': <Link href={`/lead-details/${ticket.case_id}`} target='_blank'> {ticket.cxName} </Link>,
      'sub-cat': _.get(subCategoryMap, ticket.sub_category, ticket.sub_category),
      'slot-booked': <>
            <Tag color="green">{moment(ticket.reminderDate).format('HH:mm')}</Tag>
            <Tag color="blue">{moment(ticket.reminderDate).format(' DD-MMM-YYYY')}</Tag>
      </>
      ,
      'status': ticket.status,
      'attempt': ticket.attemptCount
    }));
  }, [ticketData, startDate, endDate])
  
  
  const columns = [
    { title: 'Ticket ID', dataIndex: 'ticket-id', key: 'ticket-id' },
    { title: 'Ticket date', dataIndex: 'ticket-date', key: 'ticket-date' },
    { title: 'Order ID', dataIndex: 'order-id', key: 'order-id' },
    { title: 'Cx profile link', dataIndex: 'cx-profile-link', key: 'cx-profile-link' },
    { title: 'Sub-cat', dataIndex: 'sub-cat', key: 'sub-cat' },
    { title: 'Slot booked', dataIndex: 'slot-booked', key: 'slot-booked' },
    { title: 'Status', dataIndex: 'status', key: 'status' },
    { title: '# attempt', dataIndex: 'attempt', key: '# attempt' }
  ];
  const handleFilterClick = () => {
		let filter = '';
    let selectedStatusData = selectedStatus;
    if (selectedStatus && selectedStatus.length > 0) {
      const status = selectedStatusData.join(',');
      filter += `statusCode=${status}`;
    }
    if (inputQuery && inputQuery.length > 0) {
      const searchBy = inputQuery;
      const searchQuery = searchBy.startsWith('#') ? searchBy.replace('#', 'oid') : searchBy;
      filter += filter.length > 0 ? `&searchBy=${searchQuery}` : `searchBy=${searchQuery}`;
    }
    if (agentQuery) {
      filter += filter ? `&agent=${agentQuery}` : `agent=${agentQuery}`;
              }
		setQuery(filter);
		setNewPage(1);
	};
  const handleSearch = query => {
		inputQuery = removeSpaces(query);
		handleFilterClick();
	};

  const handleAgentSearch = (query) => {
    const cleanedAgentQuery = removeSpaces(query);
    setAgentQuery(cleanedAgentQuery);
    handleFilterClick();
  };
  return (
    <div>
      <CustomerComplaintTikcetFilter
      selectedStatus = {selectedStatus}
      setSelectedStatus = {setSelectedStatus}
      handleFilterClick = {handleFilterClick}
      handleSearch = {handleSearch}
      handleAgentSearch={handleAgentSearch}
      setStartDate = {setStartDate}
      setEndDate = {setEndDate}
      startDate = {startDate}
      endDate = {endDate}
      />
      <Table columns={columns} dataSource={dataSource} pagination={{total: rowCount, onChange: (page) => setNewPage(page)}}/>
    </div>
  )
}

export default CustomerComplaintTickets;
